import { axiosAjax } from '@app/src/config/axios';
import { PrintPostResponseDTO } from '@app/src/views/StepTwo/channelPublication/dto/PrintDTO';
import { PrintModel } from '@app/src/views/StepTwo/channelPublication/models/print';

import { hydrateData } from './hydrators';

export const printService = {
  async post(categoryId: number,json: PrintModel): Promise<PrintPostResponseDTO[]> {
    try {
      const { data } = await axiosAjax.post(process.env.API_PRINT.replace(':categoryId', String(categoryId)), hydrateData(json));
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  }
};
